import { Pipe, PipeTransform } from "@angular/core";
@Pipe({ name: "searchPipe" })

export class SearchPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (searchText.length < 3 && searchText !== "")
      return items;
    else {
      if (!items) return [];
      if (!searchText) return items;
      searchText = searchText.toLocaleLowerCase();
      return items.filter((it) => {
        return it.hasOwnProperty('name')
          ? it.name.toLocaleLowerCase().includes(searchText)
          : it.toLocaleLowerCase().includes(searchText);
      });
    }
  }
}